import { render, staticRenderFns } from "./ResearchSummaryPlot.vue?vue&type=template&id=5a97b0d4"
import script from "./ResearchSummaryPlot.vue?vue&type=script&lang=js"
export * from "./ResearchSummaryPlot.vue?vue&type=script&lang=js"
import style0 from "./ResearchSummaryPlot.vue?vue&type=style&index=0&id=5a97b0d4&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a97b0d4')) {
      api.createRecord('5a97b0d4', component.options)
    } else {
      api.reload('5a97b0d4', component.options)
    }
    module.hot.accept("./ResearchSummaryPlot.vue?vue&type=template&id=5a97b0d4", function () {
      api.rerender('5a97b0d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchSummaryPlot.vue"
export default component.exports